import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import notifier from '../../../_utils/notifier';
import { ClientSidePaginationList } from '../../hoc/ClientSidePaginationList.jsx';
import FilterSet from '../common/Filters/FilterSet.jsx';

import { getVisibleFavoriteOffers } from '../../reducers/favorite-selector';
import { getFavoritesOffers, checkAllFavoriteOffers, deleteFavoriteOffers,
  addToCartFavoriteOffers } from '../../actions/favorites';
import Sorting from '../common/Filters/Sorting.jsx';
import FavoritesInfo from './FavoritesInfo.jsx';
import FavoritesButtons from './FavoritesButtons.jsx';
import FavoritesItem from './FavoritesItem.jsx';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { ServerSidePaginationList } from "../../hoc/ServerSidePaginationList.jsx";


function Favorites(props) {
  // const checkedCount = props.paginateList.filter(o => o.is_checked).length;
  //
  // const handleDeleteCheckedClick = async () => {
  //   let offers = props.list.filter(o => o.is_checked).map(o => o.id);
  //   await props.deleteFavoriteOffers(offers);
  //   notifier.success(gettext('Выбранные товары успешно удалены.'));
  // };
  //
  // const handleCartCheckedClick = async (event) => {
  //   const btn = event.currentTarget;
  //   btn.disabled = true;
  //   let offers = props.list.filter(o => o.is_checked).map(o => o.id);
  //   const response = await props.addToCartFavoriteOffers(offers);
  //   if (response){
  //     notifier.success(gettext('Выбранные товары добавлены в корзину.'));
  //     btn.disabled = false;
  //   }
  // };

  let items;
  if (!props.isLoading) {
    if (props.count){
      // items = props.paginateList.map(item => <FavoritesItem key={ item.id }
      items = props.list.map(item => <FavoritesItem key={ item.id }
                                                    currency={ props.currency }
                                                    {...item.offer}/>);
    } else {
      items = <div>
        <p>
          { gettext('Добавляйте аранжировки и уроки в свой список пожеланий, чтобы не потерять то, что вам интересно.')
          + ' ' + gettext('Если вдруг цена на товар изменится, вы обязательно получите уведомление об этом.') }
        </p>
      </div>
    }
  }
  return <div>
    <FavoritesInfo/>
    {/*<FavoritesButtons count={ props.count }*/}
    {/*                  checkedCount={ checkedCount }*/}
    {/*                  onCheckAllClick={ props.checkAllFavoriteOffers }*/}
    {/*                  onDeleteCheckedClick={ handleDeleteCheckedClick }*/}
    {/*                  onAddToCartClick={ handleCartCheckedClick }/>*/}
    {/*<p>@todo Сверху раздела нужно вывести все те же фильтры по тегам</p>*/}
    {/*<FilterSet isLoading={ props.isLoading }*/}
    {/*           difficultyFilter={ true }*/}
    {/*           tonalityFilter={ true }*/}
    {/*           typeFilter={ true }*/}
    {/*           authorFilter={ true }*/}
    {/*           list={ props.list }*/}
    {/*           colSize={3}/>*/}
    {/*{ props.count > 0 && <Sorting fields={ ['id', 'title', 'discount_price_number', 'discount'] }/> }*/}
    { items }
  </div>
}

Favorites.propTypes = {
  currency: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
}


let mapStateToProps = (state) => {
  return {
    currency: state.auth.currency,
    // list: getVisibleFavoriteOffers(state),
    list: state.favorites.list,
    count: state.favorites.count,
  }
};

export default compose(
  connect(mapStateToProps,
    {
      loadListFromServer: getFavoritesOffers,
      checkAllFavoriteOffers, deleteFavoriteOffers, addToCartFavoriteOffers
    }),
  LoginRequired,
  ServerSidePaginationList // добавляет пагинацию со стороны сервера
  // ClientSidePaginationList
)(Favorites)

